import backgroundHero from "./backgroundHero.png";
import cloud from "./cloud.png";

const images = {
  backgroundHero,
  cloud,
};

export { images };
